/**
 * The message the API put on a failed request: the reason in a refusal body ({ error }, as
 * CallerSecurity.Forbidden and the role-level filters send it) or a short plain-text body (a
 * BadRequest / 500 message). Anything else (no response, an HTML error page, a long dump) gets
 * the fallback, so a toast never shows axios's "Request failed with status code 403".
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: unknown } })?.response?.data;
  if (data && typeof data === 'object' && typeof (data as { error?: unknown }).error === 'string') return (data as { error: string }).error;
  if (typeof data === 'string' && data.length > 0 && data.length < 300) return data;
  return fallback;
}
